import React from "react";
import { withTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";

import InputFieldText from "Components/Common/InputFieldText";
import {
  buildingAuthorityRole1Enum,
  buildingAuthorityRole2Enum,
} from "common/enums";
import SelectField from "Components/Common/SelectField";
import ResponsiblePersonDetails from "./ResponsiblePersonDetails";

const BuildingAuthorityDetails = ({ formik, t }) => {
  return (
    <>
      <Grid container columnSpacing={1} rowSpacing={1}>
        <Grid item xs={12}>
          <Typography className="mb-3 me-3" lineHeight={1} variant="h6">
            {t("Developer/ Builder/ Owner")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <SelectField
            label={t("Select Authority") + "*"}
            name={"authority.buildingAuthorityRoleId"}
            formik={formik}
            options={buildingAuthorityRole1Enum}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InputFieldText
            label={t("Name") + "*"}
            name={"authority.name"}
            formik={formik}
            placeholder="Enter Name"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InputFieldText
            label={t("Mobile Number") + "*"}
            name={"authority.mobileNumber"}
            type="number"
            formik={formik}
            placeholder="Enter Mobile Number"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InputFieldText
            label={t("Email") + "*"}
            name={"authority.email"}
            formik={formik}
            placeholder="Enter Email"
          />
        </Grid>
      </Grid>
      <Grid container columnSpacing={1} rowSpacing={1}>
        <Grid item xs={12}>
          <Typography className="mb-3 me-3" lineHeight={1} variant="h6">
            {t("Chairman/ Owner/ Occupier/ Secretary")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <SelectField
            label={t("Select Authority") + "*"}
            name={"buildingAuthority.buildingAuthorityRoleId"}
            formik={formik}
            options={buildingAuthorityRole2Enum}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InputFieldText
            label={t("Name") + "*"}
            name={"buildingAuthority.name"}
            formik={formik}
            placeholder="Enter Name"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InputFieldText
            label={t("Mobile Number") + "*"}
            name={"buildingAuthority.mobileNumber"}
            type="number"
            formik={formik}
            placeholder="Enter Mobile Number"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InputFieldText
            label={t("Email") + "*"}
            name={"buildingAuthority.email"}
            formik={formik}
            placeholder="Enter Email"
          />
        </Grid>
      </Grid>

      {/* Responsible Person Details */}
      <ResponsiblePersonDetails formik={formik} />
    </>
  );
};

BuildingAuthorityDetails.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(BuildingAuthorityDetails);
